import { Button } from "react-bootstrap";
import styles from "./updateBar.module.scss";

const UpdateBar = () => {
  const handleClick = () => {
    window.location.reload();
  };

  return (
    <div className={`bg-warning ${styles.div}`}>
      <span>App version updated. Please reload the page.</span>
      <Button onClick={handleClick} className={styles.button}>
        Reload
      </Button>
    </div>
  );
};

export default UpdateBar;
